import { useEffect, useState } from "react"
import { connect } from "react-redux"
import { useHistory } from "react-router"
import { Box, Checkbox, Divider, FormControlLabel, Grid, IconButton, InputAdornment, MenuItem, Popover, TextField, Tooltip, Typography } from "@mui/material"
import { useFormik } from "formik"
import { AppButton, Breadcrumb, CustomDialog, CustomStepper, DisplayMessage, Loader } from "../../components"
import _ from 'lodash'
import * as yup from 'yup'
import { useStyles } from "./style"
import uploadImage from '../../assets/Images/upload.svg'
import { getErrors, getHelperText, renderIcon } from '../../utils/formikHelper'
import { Add as AddIcon, Remove as RemoveIcon, InfoOutlined as InfoOutlinedIcon, ChevronRight, KeyboardArrowDown, DateRangeOutlined as DateRangeOutlinedIcon } from '@mui/icons-material'
import { applicationsService } from "../../services"
import * as messageTypes from '../../utils/messageTypes'
import { downloadFile, trimName, trimNameWithoutExtension } from '../../utils/fileUtils'
import { applicationStatus, tableApplicationStatus } from "../Applications/constant"
import { APPLICATIONSUBMITTED, steps } from "../ViewApplication/constant"
import download from '../../assets/Images/download.svg'
import calendar from '../../assets/Images/calendar.svg'
import { dashboardService } from "../../services/DashboardService"
import { BATTERYTYPE, fileAccept, fileTypeMapper, NUMBER, REGEX, yupMapper, yupValidationMapper } from "./constant"
import { FAMILY_KEY, PROGRAM_KEY } from "../../constants/common"
import downloadFileIcon from '../../assets/Images/downloadFile.svg'
import { ENROLLMENT_FORMS, pdfFiles, PROGRAMDETAILS_FILES, TANDC_FORMS } from "../../constants/files"
import { customerService } from "../../services/CustomerServices"
import moment from "moment"
import CustomDatePicker from "../../components/DatePicker"
import { pushToDataLayer, USERBEHAVIOURTRACKING } from "../../utils/gaEnvironment"

const validationSchema = yup.object({
  isEdit: yup.boolean(),
  firstName: yup.string().required('First name is required').min(2, 'First name must be min 2 characters').max(50, 'First name must be max 50 characters'),
  lastName: yup.string().required('Last name is required').min(2, 'Last name must be min 2 characters').max(50, 'Last name must be max 50 characters'),
  email: yup.string().required('Email is required').email('Enter valid email'),
  address1: yup.string().required('Address Line 1 is required').min(2, 'Address Line 1 must be min 2 characters').max(80, 'Address Line 1 must be max 80 characters'),
  address2: yup.string().min(2, 'Address Line 2 must be min 2 characters').max(80, 'Address Line 2 must be max 80 characters'),
  city: yup.string().required('City is required').min(2, 'City must be min 2 characters').max(30, 'City must be max 30 characters'),
  state: yup.string().required('State is required').min(2, 'State must be min 2 characters').max(30, 'State must be max 30 characters'),
  zip: yup.string().required('Zip is required').matches(/^[0-9]+$/, "Enter valid zip").min(5, 'Zip must be 5 characters').max(5, 'Zip must be 5 characters'),
  phone: yup.string().matches(/(^[0-9]{10})$/, 'Enter valid phone number').required('Phone number is required'),
  programOptions: yup.string().required('Please select program option'),
  ean: yup.string().required('Electric account number is required').min(8, 'Electric account number must be min 8 characters').max(12, 'Electric account number must be max 12 characters'),
  energyHubTnc: yup.string().when('isEdit', {
    is: false,
    then: yup.string().required('File is required and must be of max 10MB'),
  }),
  accept: yup.bool().oneOf([true], 'Please accept terms and conditions')
})

const enchargeText = {
  'encharge3': 'IQ Battery 3',
  'encharge10': 'IQ Battery 10',
  'encharge5P': 'IQ Battery 5P'
}

const menus = [
  { key: 'STANDARD', value: 'Standard' },
  { key: 'UNDERSERVED', value: 'Underserved' },
  { key: 'LOW_INCOME', value: 'Low Income' }
]

const ApplicationForm = (props) => {
  const classes = useStyles()

  const [cancelModal, setCancelModal] = useState(false)
  const [submitModal, setSubmitModal] = useState(false)
  const [utilityChangeModal, setUtilityChangeModal] = useState(false)
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const [uploadTouched, setUploadTouched] = useState(false)
  const [fileDownloaded, setFileDownloaded] = useState(false)
  const [loading, setLoading] = useState(false)
  const [program, setProgram] = useState()
  const [formData, setFormData] = useState()
  const [validations, setValidations] = useState()
  const [initialValues, setInitialValues] = useState({})
  const [fileModal, setFileModal] = useState(false)
  const [fileUploadTouched, setFileUploadTouched] = useState({})
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedUtility, setSelectedUtility] = useState(null)
  const [showDate, setShowDate] = useState(false)
  const [urlProgram, setUrlProgram] = useState([])
  const [programDetail, setProgramDetail] = useState()
  const [disableEncharge, setDisableEncharge] = useState(false)
  const [disable5P, setDisable5P] = useState(false)

  const search = _.get(props.location, 'search', {})
  const programId = new URLSearchParams(search).get('programs')
  const application = _.get(props, 'location.state.application', false)
  const history = useHistory()

  const formik = useFormik({
    initialValues: (program && program[0] && program[0].program_key === PROGRAM_KEY.APS_RBP) ? {
      firstName: _.get(application, 'homeowner_info.first_name', ''),
      lastName: _.get(application, 'homeowner_info.last_name', ''),
      email: _.get(application, 'homeowner_info.email_address', ''),
      address1: _.get(application, 'homeowner_info.address1', ''),
      address2: _.get(application, 'homeowner_info.address2', ''),
      city: _.get(application, 'homeowner_info.city', ''),
      state: _.get(application, 'homeowner_info.state', ''),
      zip: _.get(application, 'homeowner_info.zip', ''),
      phone: _.get(application, 'homeowner_info.phone', ''),
      encharge3: _.get(application, 'homeowner_info.encharge3', 0),
      encharge10: _.get(application, 'homeowner_info.encharge10', 0),
      programOptions: _.get(application, 'homeowner_info.program_type', ''),
      ean: _.get(application, 'homeowner_info.electric_account_number', ''),
      energyHubTnc: '',
      accept: false,
      isEdit: Boolean(application)
    } : initialValues,
    enableReinitialize: true,
    validationSchema: (program && program[0] && program[0].program_key === PROGRAM_KEY.APS_RBP) ? validationSchema : validations,
    onSubmit: (values) => {
      pushToDataLayer({ event: USERBEHAVIOURTRACKING, userID: props.currentUser.user_id, programID: programId })
      setSubmitModal(true)
    }
  })

  const handleUtilityClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleUtilityClose = () => {
    setAnchorEl(null)
  }

  const openPopover = Boolean(anchorEl)
  const id = openPopover ? 'simple-popover' : undefined

  useEffect(() => {
    if (showDate) {
      document.getElementsByClassName(`${classes.dateWrapper}`)[0].scrollIntoView()
    }
  }, [showDate])

  const getEnchargeAddDisabled = (encharge3, encharge10, type) => {
    if (type === 'encharge3') {
      return ((encharge3 * 1.28) + (encharge10 * 3.84) + 1.28) > 15.36
    } else {
      return ((encharge3 * 1.28) + (encharge10 * 3.84) + 3.84) > 15.36
    }
  }

  const restrictEnchargeCount = (encharge3, encharge10, encharge5P, type) => {
    if (type === BATTERYTYPE.ENCHARGE3) {
      return (((encharge3 * 3.36) + (encharge10 * 10.08) + (encharge5P * 5) + 3.36) > 40.32) || disableEncharge
    } else if (type === BATTERYTYPE.ENCHARGE10) {
      return (((encharge3 * 3.36) + (encharge10 * 10.08) + (encharge5P * 5) + 10.08) > 40.32) || disableEncharge
    } else {
      return (((encharge3 * 3.36) + (encharge10 * 10.08) + (encharge5P * 5) + 5) > 40.32) || disable5P || encharge5P >= 4
    }
  }

  const submitNewApplication = () => {
    setLoading(true)
    let programIds = selectedUtility && selectedUtility.id ? selectedUtility.id : programId && programId?.split(',')[0]
    const request = program && program[0] && program[0].program_key === PROGRAM_KEY.APS_RBP ?
      applicationsService.submitNewApplication(programIds, formik.values, application ? 'put' : 'post', application.application_id) :
      applicationsService.submitNewEnrollment(programIds, formik.values, application ? 'put' : 'post', application.application_id, program[0].family_key)
    request
      .then(applicationData => {
        if (program && program[0] && program[0].program_key !== PROGRAM_KEY.APS_RBP && application) {
          const body = {
            application_status: APPLICATIONSUBMITTED,
            message: 'Application Submitted',
            last_modified_by: _.get(props.currentUser, 'email', ''),
            timestamp: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
          }
          customerService.updateStatus(application.application_id, body)
            .then(updatedData => {
              setLoading(false)
              setOpen(true)
              setMessage('Application submitted successfully')
              setMessageType(messageTypes.SUCCESS)
              formik.resetForm()
              setSubmitModal(false)
              setTimeout(() => {
                history.push(`/applications?programs=${programId}`)
              }, 2000)
            })
            .catch(error => {
              setLoading(false)
              setSubmitModal(false)
              setOpen(true)
              setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
              setMessageType(messageTypes.ERROR)
            })
        } else {
          setLoading(false)
          setOpen(true)
          setMessage('Application submitted successfully')
          setMessageType(messageTypes.SUCCESS)
          formik.resetForm()
          setSubmitModal(false)
          setTimeout(() => {
            history.push(`/applications?programs=${programId}`)
          }, 2000)
        }
      })
      .catch(error => {
        setLoading(false)
        setSubmitModal(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getProgram = () => {
    const programIds = programId?.split(',')
    setLoading(true)
    dashboardService.getAllPrograms()
      .then(programsData => {
        setLoading(false)
        let filteredPrograms = programsData.filter(program => program.feature_flags && program.feature_flags.installer_intake && programIds.includes(program.id))
        setUrlProgram(new URLSearchParams({ programs: filteredPrograms.map(obj => obj.id) }))
        setProgram(filteredPrograms)
        const programClosure = filteredPrograms && filteredPrograms[0] && filteredPrograms[0].program_key === PROGRAM_KEY.APS_RBP ? true : false
        const programId = filteredPrograms && filteredPrograms[0] && filteredPrograms[0].id
        { programClosure && history.replace({ pathname: '/applications', search: `?programs=${programId}` }) }
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const goBack = (formik) => {
    if (formik.dirty) {
      setCancelModal(true)
    } else {
      history.push(`/applications?programs=${programId}`)
    }
  }

  const getCancelModalContent = () => (
    <Box>
      <Typography className={classes.modalText}>The Application is not submitted yet. Are you sure you want to leave this page?</Typography>
      <Box display="flex">
        <AppButton className={classes.modalButton} text="Yes" fill={false} onClick={() => history.push(`/applications?programs=${programId}`)} />
        <AppButton className={classes.modalButton} text="No" onClick={() => setCancelModal(false)} />
      </Box>
    </Box>
  )

  const getSubmitModalContent = () => (
    <Box>
      <Typography className={classes.modalText}>Are you sure you want to submit the application?</Typography>
      <Box display="flex">
        <AppButton className={classes.modalButton} text="Yes" onClick={() => submitNewApplication()} />
        <AppButton className={classes.modalButton} text="No" fill={false} onClick={() => setSubmitModal(false)} />
      </Box>
    </Box>
  )

  const getUtilityChangeModalContent = () => (
    <Box>
      <Typography className={classes.modalText}>{`You are about to change the Utility. Would you like to save the application details for ${selectedUtility ? selectedUtility.utility_name : 'Eversource'}?`}</Typography>
      <Box display="flex">
        <AppButton className={classes.modalButton} text="Save" onClick={() => { formik.setFieldValue('utility', programDetail.util_id); setSelectedUtility(programDetail); handleUtilityClose(); setUtilityChangeModal(false) }} />
        <AppButton className={classes.modalButton} text="No" fill={false} onClick={() => setUtilityChangeModal(false)} />
      </Box>
    </Box>
  )

  const getFiles = (type) => {
    setLoading(true)
    const programIds = programId?.split(',')
    applicationsService.downloadFiles(programIds[0], type)
      .then(fileData => {
        setLoading(false)
        setOpen(true)
        if (pdfFiles.includes(type)) {
          let popUp = window.open(fileData.presigned_url, '_blank', '')
          if (popUp == null || typeof (popUp) == 'undefined') {
            setMessage('Please disable your pop-up blocker and download file again.')
            setMessageType(messageTypes.INFO)
          }
          else {
            setMessage('Files downloading')
            setMessageType(messageTypes.SUCCESS)
          }
        } else {
          downloadFile(fileData.presigned_url)
          setMessage('Files downloading')
          setMessageType(messageTypes.SUCCESS)
        }
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getFileContent = (key) => {
    switch (key) {
      case PROGRAM_KEY.PSEG_LI: {
        return (
          <Box>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography className={classes.fileModalText}>NYSERDA Customer Attestation Form.pdf</Typography>
              <Box className={classes.fileModalIcon} onClick={() => getFiles(PROGRAMDETAILS_FILES)}><img src={downloadFileIcon} alt="" /></Box>
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography className={classes.fileModalText}>PSEG Enrolment Form.csv</Typography>
              <Box className={classes.fileModalIcon} onClick={() => getFiles(ENROLLMENT_FORMS)}><img src={downloadFileIcon} alt="" /></Box>
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography className={classes.fileModalText}>Enphase Terms and Conditions Document.pdf</Typography>
              <Box className={classes.fileModalIcon} onClick={() => getFiles(TANDC_FORMS)}><img src={downloadFileIcon} alt="" /></Box>
            </Box>
          </Box>
        )
      }
      case FAMILY_KEY.CT_ESS: {
        return (
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography className={classes.fileModalText}>Enphase Terms and Conditions Document.pdf</Typography>
            <Box className={classes.fileModalIcon} onClick={() => getFiles(TANDC_FORMS)}><img src={downloadFileIcon} alt="" /></Box>
          </Box>
        )
      }
      default: {
        return (
          <Box display="flex" justifyContent="center" alignItems="center">
            <Box fontWeight="bold">No files found to download. Please select a valid program.</Box>
          </Box>
        )
      }
    }
  }

  const getProgramDynamicForm = (programKey) => {
    setLoading(true)
    applicationsService.getDynamicForms(programKey)
      .then(formData => {
        setFormData(formData)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const createYupSchema = (schema, config) => {
    const { application_field, type, label, required, max_decimal_places, validations = [] } = config
    if (!yup[yupMapper[type]]) {
      return schema
    }
    let validator = yup[yupMapper[type]]()
    if (required) {
      validator = validator.required(label + ' is required')
    }
    if (type === NUMBER) {
      validator = validator.typeError(label + ' must be a number')
      validator = validator.test('len', `Enter valid ${label}`, (val) => { if (val) return val < Number.MAX_SAFE_INTEGER })
    }
    if (max_decimal_places) {
      let digits = [...Array(max_decimal_places).keys()].map(x => ++x)
      validator = validator.test(
        'maxDigitsAfterDecimal',
        `Only ${max_decimal_places} decimal places allowed`,
        (number) => new RegExp(`^\\d+(\\.\\d{${digits.join(',')}})?$`).test(number)
      )
    }
    validations.forEach(validation => {
      const { value, type, message } = validation
      if (!validator[yupValidationMapper[type]]) {
        return
      }
      let params
      if (type === REGEX) {
        params = [new RegExp(`^${value}$`), message]
      } else {
        params = [value, message]
      }
      validator = validator[yupValidationMapper[type]](...params)
    })
    schema[application_field] = validator
    return schema
  }

  const createFileYupSchema = (schema, config) => {
    const { application_field, validations = [] } = config
    if (!application) {
      let validator = yup.string()
      validator = validator.required('File is required and must be of max 10MB')
      schema[application_field] = validator
    }
    return schema
  }

  const getInitialValues = (formData, application) => {
    let initialValues = {}
    formData.fields.forEach(field => {
      initialValues[field.application_field] = application ? application[field.application_field] || application.homeowner_info[field.application_field] : field.type === "GROUPABLE_COUNTER" ? 0 : ""
      if (field.data_type === 'ENUM') {

      }
      if (field.application_field === BATTERYTYPE.ENCHARGE5P && !application[field.application_field]) {
        initialValues[field.application_field] = 0
      }
    })
    formData.files.forEach(file => {
      initialValues[file.application_field] = ''
    })
    return initialValues
  }

  useEffect(() => {
    getProgram()
  }, [programId])

  useEffect(() => {
    if (program && program[0] && program[0].program_key !== PROGRAM_KEY.APS_RBP) {
      if (application && program) {
        program.map(programDetail => {
          if (programDetail.id === application.program_id) {
            setSelectedUtility(programDetail)
            formik.setFieldValue('utility', programDetail.util_id)
          }
        })
      } else if (program) {
        setSelectedUtility(program[0])
        formik.setFieldValue('utility', program[0].util_id)
      }
    }
  }, [application, program])

  useEffect(() => {
    if (program && program[0] && program[0].program_key !== PROGRAM_KEY.APS_RBP) {
      getProgramDynamicForm(program[0].program_key)
    }
  }, [program])

  useEffect(() => {
    if (formData) {
      let validationSchema = yup.object().shape({ ...formData.fields.reduce(createYupSchema, { accept: yup.bool().oneOf([true], 'Please accept terms and conditions') }), ...formData.files.reduce(createFileYupSchema, {}) })
      let initialValues = getInitialValues(formData, application)
      initialValues = { ...initialValues, ...{ accept: false } }
      if (initialValues.encharge3 > 0 || initialValues.encharge10 > 0) {
        setDisable5P(true)
      } else if (initialValues[BATTERYTYPE.ENCHARGE5P] > 0) {
        setDisableEncharge(true)
      }
      setValidations(validationSchema)
      setInitialValues(initialValues)
    }
  }, [formData])

  return (
    <Box>
      <Loader loading={loading} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      <CustomDialog open={cancelModal} fullWidth maxWidth="xs" title="" content={getCancelModalContent()} handleClose={() => setCancelModal(false)} />
      <CustomDialog open={submitModal} fullWidth maxWidth="xs" title="" content={getSubmitModalContent()} handleClose={() => setSubmitModal(false)} />
      <CustomDialog open={utilityChangeModal} fullWidth maxWidth="xs" title="" content={getUtilityChangeModalContent()} handleClose={() => setUtilityChangeModal(false)} />
      {fileModal && <CustomDialog open={fileModal} title='Download Program Documents' content={getFileContent(program && program[0] && program[0].family_key ? program[0].family_key : program[0].program_key)} fullWidth maxWidth="xs" handleClose={() => setFileModal(false)} />}
      <Breadcrumb value={[{ 'Dashboard': '/' }, { [program && program[0] ? program[0].name : '']: `/applications`, search: urlProgram }, { [application ? 'Edit application' : 'Submit new application']: `/applications/${programId}/application-form` }]} />
      <Box className={classes.headerWrapper} display="flex" flexWrap="wrap">
        <Box>
          <Typography className={classes.title}>{application ? `Edit Application For Application ID: ${application.application_id}` : 'Submit new application'}</Typography>
        </Box>
        <Box className={classes.buttonContainer}>
          {program && program[0] && program[0].program_key === PROGRAM_KEY.APS_RBP && <AppButton className={classes.buttons} text="Download T&C forms for homeowner’s signatures" fill={false} onClick={() => getFiles()} />}
          {program && program[0] && program[0].program_key === PROGRAM_KEY.PSEG_LI && <AppButton className={classes.buttons} text="Download Program Documents" fill={false} onClick={() => setFileModal(true)} />}
          {program && program[0] && program[0].family_key === FAMILY_KEY.CT_ESS && <AppButton className={`${classes.mr4} ${classes.iconButtons}`} text={<img src={download} className={classes.buttonIcons} alt="" />} fill={false} onClick={() => setFileModal(true)} />}
        </Box>
      </Box>
      <Box className={classes.stepperContainer}>
        {program && program[0] && program[0].program_key && <CustomStepper steps={steps} currentStep={application ? tableApplicationStatus[program && program[0] ? program[0].family_key ? program[0].family_key : program[0].program_key : ''] && tableApplicationStatus[program && program[0] ? program[0].family_key ? program[0].family_key : program[0].program_key : ''][application.application_status][2] : fileDownloaded ? 1 : 0} status={application && application.application_status} formData={formData} program={program && program[0]} />}
      </Box>
      <Box className={classes.formContainer}>
        {program && program[0] && program[0].program_key === PROGRAM_KEY.APS_RBP &&
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Box className={classes.formHeading} p={1}>Enter the following details</Box>
                <Box m={1}>
                  <TextField
                    fullWidth
                    className={classes.formInput}
                    label="Customer First Name"
                    name="firstName"
                    variant="standard"
                    onChange={formik.handleChange}
                    onBlur={(e) => formik.setFieldValue('firstName', e.target.value.trim())}
                    value={formik.values.firstName}
                    InputProps={{
                      endAdornment: renderIcon(formik.errors.firstName, formik.values.firstName, formik.touched.firstName),
                    }}
                    error={getErrors(formik.errors.firstName, formik.values.firstName, formik.touched.firstName)}
                    helperText={getHelperText(formik.errors.firstName, formik.values.firstName, formik.touched.firstName)}
                  />
                </Box>
                <Box m={1}>
                  <TextField
                    fullWidth
                    className={classes.formInput}
                    label="Customer Last Name"
                    name="lastName"
                    variant="standard"
                    onChange={formik.handleChange}
                    onBlur={(e) => formik.setFieldValue('lastName', e.target.value.trim())}
                    value={formik.values.lastName}
                    InputProps={{
                      endAdornment: renderIcon(formik.errors.lastName, formik.values.lastName, formik.touched.lastName),
                    }}
                    error={getErrors(formik.errors.lastName, formik.values.lastName, formik.touched.lastName)}
                    helperText={getHelperText(formik.errors.lastName, formik.values.lastName, formik.touched.lastName)}
                  />
                </Box>
                <Box m={1}>
                  <TextField
                    fullWidth
                    className={classes.formInput}
                    label="Email address"
                    name="email"
                    variant="standard"
                    onChange={formik.handleChange}
                    onBlur={(e) => formik.setFieldValue('email', e.target.value.trim())}
                    value={formik.values.email}
                    InputProps={{
                      endAdornment: renderIcon(formik.errors.email, formik.values.email, formik.touched.email),
                    }}
                    error={getErrors(formik.errors.email, formik.values.email, formik.touched.email)}
                    helperText={getHelperText(formik.errors.email, formik.values.email, formik.touched.email)}
                  />
                </Box>
                <Box m={1}>
                  <TextField
                    fullWidth
                    className={classes.formInput}
                    label="Address Line 1 (Street address, etc)"
                    name="address1"
                    variant="standard"
                    onChange={formik.handleChange}
                    onBlur={(e) => formik.setFieldValue('address1', e.target.value.trim())}
                    value={formik.values.address1}
                    InputProps={{
                      endAdornment: renderIcon(formik.errors.address1, formik.values.address1, formik.touched.address1),
                    }}
                    error={getErrors(formik.errors.address1, formik.values.address1, formik.touched.address1)}
                    helperText={getHelperText(formik.errors.address1, formik.values.address1, formik.touched.address1)}
                  />
                </Box>
                <Box m={1}>
                  <TextField
                    fullWidth
                    className={classes.formInput}
                    label="Address Line 2 (Apartment, building, floor, etc) (Optional)"
                    name="address2"
                    variant="standard"
                    onChange={formik.handleChange}
                    onBlur={(e) => formik.setFieldValue('address2', e.target.value.trim())}
                    value={formik.values.address2}
                    InputProps={{
                      endAdornment: renderIcon(formik.errors.address2, formik.values.address2, formik.touched.address2),
                    }}
                    error={getErrors(formik.errors.address2, formik.values.address2, formik.touched.address2)}
                    helperText={getHelperText(formik.errors.address2, formik.values.address2, formik.touched.address2)}
                  />
                </Box>
                <Box m={1}>
                  <TextField
                    fullWidth
                    className={classes.formInput}
                    label="City"
                    name="city"
                    variant="standard"
                    onChange={formik.handleChange}
                    onBlur={(e) => formik.setFieldValue('city', e.target.value.trim())}
                    value={formik.values.city}
                    InputProps={{
                      endAdornment: renderIcon(formik.errors.city, formik.values.city, formik.touched.city),
                    }}
                    error={getErrors(formik.errors.city, formik.values.city, formik.touched.city)}
                    helperText={getHelperText(formik.errors.city, formik.values.city, formik.touched.city)}
                  />
                </Box>
                <Box m={1}>
                  <TextField
                    fullWidth
                    className={classes.formInput}
                    label="State"
                    name="state"
                    variant="standard"
                    onChange={formik.handleChange}
                    onBlur={(e) => formik.setFieldValue('state', e.target.value.trim())}
                    value={formik.values.state}
                    InputProps={{
                      endAdornment: renderIcon(formik.errors.state, formik.values.state, formik.touched.state),
                    }}
                    error={getErrors(formik.errors.state, formik.values.state, formik.touched.state)}
                    helperText={getHelperText(formik.errors.state, formik.values.state, formik.touched.state)}
                  />
                </Box>
                <Box m={1}>
                  <TextField
                    fullWidth
                    className={classes.formInput}
                    label="Zip"
                    name="zip"
                    variant="standard"
                    onChange={formik.handleChange}
                    onBlur={(e) => formik.setFieldValue('zip', e.target.value.trim())}
                    value={formik.values.zip}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]*/g, '')
                    }}
                    InputProps={{
                      endAdornment: renderIcon(formik.errors.zip, formik.values.zip, formik.touched.zip),
                    }}
                    error={getErrors(formik.errors.zip, formik.values.zip, formik.touched.zip)}
                    helperText={getHelperText(formik.errors.zip, formik.values.zip, formik.touched.zip)}
                  />
                </Box>
                <Box m={1}>
                  <TextField
                    fullWidth
                    className={classes.formInput}
                    label="Phone Number"
                    name="phone"
                    variant="standard"
                    onChange={formik.handleChange}
                    onBlur={(e) => formik.setFieldValue('phone', e.target.value.trim())}
                    value={formik.values.phone}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]*/g, '')
                    }}
                    InputProps={{
                      endAdornment: renderIcon(formik.errors.phone, formik.values.phone, formik.touched.phone),
                    }}
                    error={getErrors(formik.errors.phone, formik.values.phone, formik.touched.phone)}
                    helperText={getHelperText(formik.errors.phone, formik.values.phone, formik.touched.phone)}
                  />
                </Box>
                <Box className={classes.formSubheading} m={1} mt={2}>
                  Battery Details
                </Box>
                <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" maxWidth="500px" m={1} mb={2}>
                  <Typography>Encharge 3</Typography>
                  <Box display="flex" alignItems="center">
                    <IconButton disabled={formik.values.encharge3 <= 0} onClick={() => formik.setFieldValue('encharge3', formik.values.encharge3 - 1)}>
                      <RemoveIcon className={formik.values.encharge3 <= 0 ? classes.disabledButton : classes.adornmentIcons} />
                    </IconButton>
                    <Typography className={classes.enchargeValueWrapper}>{formik.values.encharge3}</Typography>
                    <IconButton disabled={getEnchargeAddDisabled(formik.values.encharge3, formik.values.encharge10, 'encharge3')} onClick={() => formik.setFieldValue('encharge3', formik.values.encharge3 + 1)}>
                      <AddIcon className={getEnchargeAddDisabled(formik.values.encharge3, formik.values.encharge10, 'encharge3') ? classes.disabledButton : classes.adornmentIcons} />
                    </IconButton>
                  </Box>
                </Box>
                <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" maxWidth="500px" m={1} my={2}>
                  <Typography>Encharge 10</Typography>
                  <Box display="flex" alignItems="center">
                    <IconButton disabled={formik.values.encharge10 <= 0} onClick={() => formik.setFieldValue('encharge10', formik.values.encharge10 - 1)}>
                      <RemoveIcon className={formik.values.encharge10 <= 0 ? classes.disabledButton : classes.adornmentIcons} />
                    </IconButton>
                    <Typography className={classes.enchargeValueWrapper}>{formik.values.encharge10}</Typography>
                    <IconButton disabled={getEnchargeAddDisabled(formik.values.encharge3, formik.values.encharge10, 'encharge10')} onClick={() => formik.setFieldValue('encharge10', formik.values.encharge10 + 1)} >
                      <AddIcon className={getEnchargeAddDisabled(formik.values.encharge3, formik.values.encharge10, 'encharge10') ? classes.disabledButton : classes.adornmentIcons} />
                    </IconButton>
                  </Box>
                </Box>
                <Box m={1}>
                  <Typography className={classes.formSubheading}>kW Capacity Committed for data sharing</Typography>
                  <Typography mt={1}>{((formik.values.encharge3 * 1.28) + (formik.values.encharge10 * 3.84)).toFixed(2)}</Typography>
                  {formik.touched.encharge3 && formik.touched.encharge10 && ((formik.values.encharge3 * 1.28) + (formik.values.encharge10 * 3.84)) <= 0 && <div className={classes.error}>kW capacity must be greater than 0</div>}
                </Box>
                <Box m={1}>
                  <TextField
                    fullWidth
                    select
                    className={classes.formInput}
                    label="Program Option"
                    name="programOptions"
                    variant="standard"
                    onChange={formik.handleChange}
                    value={formik.values.programOptions}
                    error={getErrors(formik.errors.programOptions, formik.values.programOptions, formik.touched.programOptions)}
                    helperText={getHelperText(formik.errors.programOptions, formik.values.programOptions, formik.touched.programOptions)}
                  >
                    <MenuItem value="DATA_ONLY">Data Only</MenuItem>
                    <MenuItem value="DATA_AND_DISPATCH">Data And Dispatch</MenuItem>
                  </TextField>
                </Box>
                <Box m={1}>
                  <TextField
                    fullWidth
                    className={classes.formInput}
                    label="Electric Account Number"
                    name="ean"
                    variant="standard"
                    onChange={formik.handleChange}
                    onBlur={(e) => formik.setFieldValue('ean', e.target.value.trim())}
                    value={formik.values.ean}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]*/g, '')
                    }}
                    InputProps={{
                      endAdornment: renderIcon(formik.errors.ean, formik.values.ean, formik.touched.ean),
                    }}
                    error={getErrors(formik.errors.ean, formik.values.ean, formik.touched.ean)}
                    helperText={getHelperText(formik.errors.ean, formik.values.ean, formik.touched.ean)}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box className={classes.formHeading} p={1}>Files to be uploaded</Box>
                <Box display="flex" flexWrap="wrap">
                  <div className={classes.formPaper}>
                    <img src={uploadImage} alt="" />
                    <Box className={classes.uploadText}>
                      Scanned Copy of Program T&C Document
                    </Box>
                    <input
                      accept=".pdf"
                      className={classes.uploadInput}
                      id="energyHubTnc"
                      name="energyHubTnc"
                      type="file"
                      onClick={(e) => e.target.value = ''}
                      onChange={(e) => {
                        let file
                        if (e.target.files && e.target.files[0] && e.target.files[0].type !== 'application/pdf') {
                          setOpen(true)
                          setMessage('Only PDF files are allowed')
                          setMessageType(messageTypes.ERROR)
                        } else {
                          file = e.target.files && e.target.files[0]
                          setUploadTouched(true)
                        }
                        if (file) {
                          if (file.size <= 10485760) {
                            formik.setFieldValue('energyHubTnc', file)
                          } else {
                            formik.setFieldError('energyHubTnc', 'File is required and must be of max 10MB')
                          }
                        }
                      }}
                    />
                    <label htmlFor="energyHubTnc" style={{ width: "100%" }}>
                      <AppButton className={classes.uploadButton} fullWidth text={`${formik.values.energyHubTnc ? "Re-Upload" : "Upload"}`} fill={false} component="span" />
                    </label>
                    {formik.values.energyHubTnc && <div className={classes.fileName}>{trimName(formik.values.energyHubTnc.name)}</div>}
                    {uploadTouched && formik.errors.energyHubTnc && <div className={`${classes.error} ${classes.center}`}>{formik.errors.energyHubTnc}</div>}
                    {!formik.values.energyHubTnc && application && application.signed_tandc_form_downloadable_url &&
                      <Box className={`${classes.fileName} ${classes.fileEdit}`} component="span" onClick={() => { application && application.signed_tandc_form_downloadable_url && downloadFile(application.signed_tandc_form_downloadable_url, 'blank') }}>
                        <Box><img src={download} className={classes.downloadIcon} alt="" />
                          {trimNameWithoutExtension(application.signed_tandc_form_url.split('/')[application.signed_tandc_form_url.split('/').length - 1])}</Box>
                      </Box>
                    }
                    <Box className={classes.uploadHelperText}>
                      <Box my={1}>
                        File number limit : 1
                      </Box>
                      <Box my={1}>
                        Size limit : 10MB
                      </Box>
                      <Box my={1}>
                        Allowed file types : PDF
                      </Box>
                    </Box>
                  </div>
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Box mt={1} mx={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="accept"
                        name="accept"
                        size="small"
                        checked={formik.values.accept}
                        onChange={() => {
                          formik.setFieldValue('accept', !formik.values.accept)
                        }}
                        color="primary"
                      />
                    }
                    label={(
                      <div className={classes.checkboxLabel}>
                        I confirm the following :
                      </div>
                    )}
                  />
                </Box>
                <Box>
                  <ul className={classes.lists}>
                    <li className={classes.formCheckboxLabel}>
                      I am authorized to submit the documents that I have uploaded using
                      this site, and have received permission from the applicant to submit
                      this information to Enphase on the applicant’s behalf.
                    </li>
                    <li className={classes.formCheckboxLabel}>
                      I have read and understand{' '}
                      <a href="https://enphase.com/privacy" className={classes.links} target="_blank" rel="noopener noreferrer">
                        Enphase’s Privacy Policy{' '}
                      </a> and{' '}
                      <a href="https://enphase.com/terms" className={classes.links} target="_blank" rel="noopener noreferrer">
                        Terms of Service
                      </a>{' '}(the “Policies”).{' '}
                    </li>
                    <li className={classes.formCheckboxLabel}>
                      The applicant has acknowledged that they have read and understand the Policies.{' '}
                    </li>
                  </ul>
                </Box>
              </Grid>
            </Grid>
            <Box mt={4}>
              <Divider />
            </Box>
            <Box display="flex" justifyContent="flex-end" width="100%">
              <Box display="flex" flexWrap="wrap" width="100%" maxWidth="500px">
                <AppButton text="Back" fill={false} onClick={() => goBack(formik)} />
                <AppButton type="submit" text="Submit" disabled={!(formik.dirty && formik.isValid && ((formik.values.encharge3 * 1.28) + (formik.values.encharge10 * 3.84)) > 0)} />
              </Box>
            </Box>
          </form>}
        {program && program[0] && program[0].program_key !== PROGRAM_KEY.APS_RBP && formData &&
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Box className={classes.formHeading} p={1}>Enter the following details</Box>
                {program[0].family_key &&
                  <Box m={1} id={'utility'}>
                    <TextField
                      fullWidth
                      className={classes.formInput}
                      label='Utility'
                      name="utility"
                      variant="standard"
                      readOnly
                      value={''}
                      InputProps={{
                        readOnly: true,
                        classes: { input: classes.utilityInput },
                        startAdornment: <Box width="100%">{selectedUtility ? selectedUtility?.utility_name?.toUpperCase() : selectedUtility}</Box>,
                        endAdornment:
                          <InputAdornment position="end" sx={{ marginRight: '5px' }}>
                            <KeyboardArrowDown fontSize="small" sx={{ cursor: 'pointer' }} />
                          </InputAdornment>,
                      }}
                      onClick={handleUtilityClick}
                    />
                    <Popover
                      id={id}
                      open={openPopover}
                      anchorEl={anchorEl}
                      onClose={handleUtilityClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      classes={{ paper: classes.paper }}
                    >
                      {program.length >= 0 && program.map(programDetail => (
                        <MenuItem key={programDetail.id} value={programDetail.id} onClick={() => {
                          if (!selectedUtility) {
                            formik.setFieldValue('utility', programDetail.util_id); setSelectedUtility(programDetail); handleUtilityClose()
                          } else if (programDetail.id !== selectedUtility.id) {
                            formik.setFieldValue('utility', programDetail.util_id); setSelectedUtility(programDetail); handleUtilityClose(); setProgramDetail(programDetail)
                          } else {
                            handleUtilityClose()
                          }
                        }} divider>
                          <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                            {programDetail.utility_name?.toUpperCase()}
                          </Box>
                        </MenuItem>
                      )
                      )}
                    </Popover>
                  </Box>
                }
                {formData.fields.map(field => (
                  !field.hidden ?
                    field.type === 'DATE' ?
                      <Box m={1} id={field.application_field}>
                        <TextField
                          fullWidth
                          className={classes.formInput}
                          label={field.label}
                          name={field.application_field}
                          value={formik.values[field.application_field] && moment(formik.values[field.application_field]).format('DD/MM/YYYY')}
                          fullWidth
                          variant="standard"
                          InputProps={{
                            endAdornment: <>
                              <img src={calendar} style={{ marginRight: '5px' }} />
                              {renderIcon(formik.errors[field.application_field], formik.values[field.application_field], formik.touched[field.application_field])}
                            </>,
                            readOnly: true
                          }}
                          onClick={() => setShowDate(true)}
                          InputLabelProps={{ shrink: formik.values[field.application_field] ? true : undefined }}
                          label={field.label}
                          style={{ maxWidth: 500 }}
                          error={getErrors(formik.errors[field.application_field], formik.values[field.application_field], formik.touched[field.application_field])}
                          helperText={getHelperText(formik.errors[field.application_field], formik.values[field.application_field], formik.touched[field.application_field])}
                        />
                        {showDate &&
                          <Box className={classes.dateWrapper}>
                            <CustomDatePicker value={formik.values[field.application_field]} handleCancel={() => { formik.setFieldValue([field.application_field], ''); setShowDate(false) }}
                              handleDone={((data) => { data.date && formik.setFieldValue([field.application_field], data.date); setShowDate(false) })} />
                          </Box>
                        }
                      </Box> :
                      field.data_type === 'ENUM' ?
                        <Box m={1} id={field.application_field}>
                          <TextField
                            fullWidth
                            select
                            className={classes.formInput}
                            label={field.label}
                            disabled={!field.enabled}
                            name={field.application_field}
                            variant="standard"
                            onChange={formik.handleChange}
                            value={!_.isNil(formik.values[field.application_field]) && formik.values[field.application_field]}
                            SelectProps={{
                              IconComponent: KeyboardArrowDown,
                              classes: { icon: (formik.values[field.application_field] || formik.touched[field.application_field]) && classes.customArrowIcon }
                            }}
                            InputProps={{
                              endAdornment: renderIcon(formik.errors[field.application_field], formik.values[field.application_field], formik.touched[field.application_field]),
                            }}
                            error={getErrors(formik.errors[field.application_field], formik.values[field.application_field], formik.touched[field.application_field])}
                            helperText={getHelperText(formik.errors[field.application_field], formik.values[field.application_field], formik.touched[field.application_field])}
                          >
                            {field.validations && field.validations[0] && field.validations[0].value.split('|').map((value, index) => (
                              <MenuItem key={value} value={value} divider={index < 2}>{value.toLowerCase().replace(/([^a-z]|^)([a-z])(?=[a-z]{2})/g, (_, g1, g2) => g1 + g2.toUpperCase()).replace('_', ' ') + `${value ? ' User' : ''}`}</MenuItem>
                            ))}
                          </TextField>
                        </Box> :
                        field.type === 'GROUPABLE_COUNTER' ?
                          <>
                            {field.application_field === 'encharge3' &&
                              <Box className={classes.formSubheading} m={1} mt={2}>
                                {field.label}
                              </Box>
                            }
                            <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" maxWidth="500px" m={1} className={classes.enchargeFieldWrapper}>
                              <Typography>{enchargeText[field.application_field]}</Typography>
                              <Box display="flex" alignItems="center">
                                <IconButton disabled={formik.values[field.application_field] <= 0} onClick={() => {
                                  formik.setFieldValue([field.application_field], formik.values[field.application_field] - 1)
                                  if (field.application_field === BATTERYTYPE.ENCHARGE3) {
                                    if (formik.values.encharge3 - 1 === 0 && formik.values.encharge10 === 0)
                                      setDisable5P(false)
                                    formik.setFieldValue('kw_capacity_committed', (0.16 * (((formik.values.encharge3 - 1) * 3.36) + (formik.values.encharge10 * 10.08) + (formik.values.encharge5P * 5))).toFixed(2))
                                  } else if (field.application_field === BATTERYTYPE.ENCHARGE10) {
                                    if (formik.values.encharge10 - 1 === 0 && formik.values.encharge3 === 0)
                                      setDisable5P(false)
                                    formik.setFieldValue('kw_capacity_committed', (0.16 * ((formik.values.encharge3 * 3.36) + ((formik.values.encharge10 - 1) * 10.08) + (formik.values.encharge5P * 5))).toFixed(2))
                                  } else {
                                    if (formik.values.encharge5P - 1 === 0)
                                      setDisableEncharge(false)
                                    formik.setFieldValue('kw_capacity_committed', (0.16 * ((formik.values.encharge3 * 3.36) + (formik.values.encharge10 * 10.08) + ((formik.values.encharge5P - 1) * 5))).toFixed(2))
                                  }
                                }}>
                                  <RemoveIcon className={formik.values[field.application_field] <= 0 ? classes.disabledButton : classes.adornmentIcons} />
                                </IconButton>
                                <Typography className={classes.enchargeValueWrapper}>{formik.values[field.application_field]}</Typography>
                                <IconButton disabled={restrictEnchargeCount(formik.values.encharge3, formik.values.encharge10, formik.values.encharge5P, field.application_field)} onClick={() => {
                                  formik.setFieldValue([field.application_field], formik.values[field.application_field] + 1)
                                  if (field.application_field === BATTERYTYPE.ENCHARGE3) {
                                    setDisable5P(true)
                                    formik.setFieldValue('kw_capacity_committed', (0.16 * (((formik.values.encharge3 + 1) * 3.36) + (formik.values.encharge10 * 10.08) + (formik.values.encharge5P * 5))).toFixed(2))
                                  } else if (field.application_field === BATTERYTYPE.ENCHARGE10) {
                                    setDisable5P(true)
                                    formik.setFieldValue('kw_capacity_committed', (0.16 * ((formik.values.encharge3 * 3.36) + ((formik.values.encharge10 + 1) * 10.08) + (formik.values.encharge5P * 5))).toFixed(2))
                                  } else {
                                    setDisableEncharge(true)
                                    formik.setFieldValue('kw_capacity_committed', (0.16 * ((formik.values.encharge3 * 3.36) + (formik.values.encharge10 * 10.08) + ((formik.values.encharge5P + 1) * 5))).toFixed(2))
                                  }
                                }}>
                                  <AddIcon className={restrictEnchargeCount(formik.values.encharge3, formik.values.encharge10, formik.values.encharge5P, field.application_field) ? classes.disabledButton : classes.adornmentIcons} />
                                </IconButton>
                              </Box>
                            </Box>
                            {field.application_field === BATTERYTYPE.ENCHARGE5P && <Box className={classes.error} m={1}>{getHelperText(formik.errors.kw_capacity_committed, formik.values.kw_capacity_committed, formik.touched.kw_capacity_committed)}</Box>}
                          </> :
                          field.read_only ?
                            <Box mx={1} mt={1.5}>
                              <Box display="flex" justifyContent="start" alignItems="center">
                                <Box className={classes.formSubheading}>{field.label}</Box>
                                <Box display="flex" mx={1}>{field.tooltip_msg &&
                                  <Tooltip title={<Box className={classes.customPopperText}>{field.tooltip_msg}</Box>} classes={{ tooltip: classes.customPopper }}>
                                    <InfoOutlinedIcon color="primary" sx={{ fontSize: '18px', cursor: 'pointer' }} />
                                  </Tooltip>}
                                </Box>
                              </Box>
                              <Typography mt={1}>{formik.values.kw_capacity_committed ? formik.values.kw_capacity_committed : Number(0).toFixed(2)}</Typography>
                            </Box> :
                            <Box m={1} id={field.application_field}>
                              <TextField
                                fullWidth
                                className={classes.formInput}
                                label={field.label}
                                disabled={!field.enabled}
                                name={field.application_field}
                                variant="standard"
                                onInput={(e) => {
                                  if (field.application_field === 'site_id') {
                                    e.target.value = e.target.value ? e.target.value.toString().replace(/\D/g, '') : ''
                                  }
                                  if (field.max_decimal_places) {
                                    e.target.value = e.target.value ? e.target.value.toString().match(new RegExp(`^-?\\d+(?:\\.\\d{0,${field.max_decimal_places}})?`)) ? e.target.value.toString().match(new RegExp(`^-?\\d+(?:\\.\\d{0,${field.max_decimal_places}})?`))[0] : '' : ''
                                  }
                                }}
                                onChange={formik.handleChange}
                                onBlur={(e) => formik.setFieldValue(field.application_field, e.target.value.trim())}
                                value={formik.values[field.application_field]}
                                InputProps={{
                                  endAdornment: renderIcon(formik.errors[field.application_field], formik.values[field.application_field], formik.touched[field.application_field]),
                                }}
                                InputProps={field.tooltip_msg ? {
                                  readOnly: field.read_only,
                                  endAdornment:
                                    <>
                                      <InputAdornment position="end" sx={{ marginRight: '5px' }}>
                                        <Tooltip title={<Box className={classes.customPopperText}>{field.tooltip_msg}</Box>} classes={{ tooltip: classes.customPopper }}>
                                          <InfoOutlinedIcon color="primary" fontSize="small" sx={{ cursor: 'pointer' }} />
                                        </Tooltip>
                                      </InputAdornment>
                                      {renderIcon(formik.errors[field.application_field], formik.values[field.application_field], formik.touched[field.application_field])}
                                    </>
                                } : {
                                  readOnly: field.read_only,
                                  endAdornment:
                                    renderIcon(formik.errors[field.application_field], formik.values[field.application_field], formik.touched[field.application_field])
                                }}
                                InputLabelProps={{
                                  shrink: field.read_only && formik.values[field.application_field] ? true : undefined,
                                }}
                                error={getErrors(formik.errors[field.application_field], formik.values[field.application_field], formik.touched[field.application_field])}
                                helperText={getHelperText(formik.errors[field.application_field], formik.values[field.application_field], formik.touched[field.application_field])}
                              />
                            </Box> : null
                ))}
              </Grid>
              <Grid item xs={12} md={6}>
                <Box className={classes.formHeading} p={1}>Files to be uploaded</Box>
                <Box display="flex" flexWrap="wrap">
                  {formData.files.map(fileData => (
                    <div className={classes.formPaper} style={{ maxWidth: '200px', justifyContent: 'stretch' }}>
                      <Box display="flex" justifyContent="center">
                        <img src={uploadImage} alt="" />
                      </Box>
                      <Box className={classes.uploadText} minHeight="50px">
                        {fileData.label}
                        <Box className={classes.requiredText}>
                          {fileData.required ? '(*Required)' : ''}
                        </Box>
                      </Box>
                      <input
                        accept={fileData.media_type}
                        className={classes.uploadInput}
                        id={fileData.application_field}
                        name={fileData.application_field}
                        type="file"
                        onClick={(e) => e.target.value = ''}
                        onChange={(e) => {
                          let file
                          if (e.target.files && e.target.files[0] && e.target.files[0].type !== fileAccept[fileData.media_type]) {
                            setOpen(true)
                            setMessage(`Only ${fileData.media_type && fileTypeMapper[fileData.media_type]} files are allowed`)
                            setMessageType(messageTypes.ERROR)
                          } else {
                            file = e.target.files && e.target.files[0]
                            setFileUploadTouched(prev => ({ ...prev, [fileData.application_field]: true }))
                          }
                          if (file) {
                            if (file.size <= 10485760) {
                              formik.setFieldValue(fileData.application_field, file)
                            } else {
                              formik.setFieldError(fileData.application_field, 'File is required and must be of max 10MB')
                            }
                          }
                        }}
                      />
                      <label htmlFor={fileData.application_field} style={{ width: "100%" }}>
                        <AppButton className={classes.uploadButton} fullWidth text={`${formik.values[fileData.application_field] ? "Re-Upload" : "Upload"}`} fill={false} component="span" />
                      </label>
                      {formik.values[fileData.application_field] && <div className={classes.fileName}>{trimName(formik.values[fileData.application_field].name)}</div>}
                      {fileUploadTouched[fileData.application_field] && formik.errors[fileData.application_field] && <div className={`${classes.error} ${classes.center}`}>{formik.errors[fileData.application_field]}</div>}
                      {!formik.values[fileData.application_field] && application && application[fileData.downloadable_url_field] &&
                        <Box className={`${classes.fileName} ${classes.fileEdit}`} component="span" onClick={() => { application && application[fileData.downloadable_url_field] && downloadFile(application[fileData.downloadable_url_field], 'blank') }}>
                          <Box><img src={download} className={classes.downloadIcon} alt="" />
                            {trimName(application[fileData.s3_url_field].split('/')[application[fileData.s3_url_field].split('/').length - 1])}</Box>
                        </Box>
                      }
                      <Box className={classes.uploadHelperText}>
                        <Box my={1}>
                          File number limit : 1
                        </Box>
                        <Box my={1}>
                          Size limit : 10MB
                        </Box>
                        <Box my={1}>
                          Allowed file types : {fileData.media_type && fileTypeMapper[fileData.media_type]}
                        </Box>
                      </Box>
                    </div>
                  ))}
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Box mt={1} mx={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="accept"
                        name="accept"
                        size="small"
                        checked={formik.values.accept}
                        onChange={() => {
                          formik.setFieldValue('accept', !formik.values.accept)
                        }}
                        color="primary"
                      />
                    }
                    label={(
                      <div className={classes.checkboxLabel}>
                        I confirm the following :
                      </div>
                    )}
                  />
                </Box>
                <Box>
                  <ul className={classes.lists}>
                    <li className={classes.formCheckboxLabel}>
                      I am authorized to submit the documents that I have uploaded using
                      this site, and have received permission from the applicant to submit
                      this information to Enphase on the applicant’s behalf.
                    </li>
                    <li className={classes.formCheckboxLabel}>
                      I have read and understand{' '}
                      <a href="https://enphase.com/privacy" className={classes.links} target="_blank" rel="noopener noreferrer">
                        Enphase’s Privacy Policy{' '}
                      </a> and{' '}
                      <a href="https://enphase.com/terms" className={classes.links} target="_blank" rel="noopener noreferrer">
                        Terms of Service
                      </a>{' '}(the “Policies”).{' '}
                    </li>
                    <li className={classes.formCheckboxLabel}>
                      The applicant has acknowledged that they have read and understand the Policies.{' '}
                    </li>
                  </ul>
                </Box>
              </Grid>
            </Grid>
            <Box mt={4}>
              <Divider />
            </Box>
            <Box display="flex" justifyContent="flex-end" width="100%">
              <Box display="flex" flexWrap="wrap" width="100%" maxWidth="500px">
                <AppButton text="Back" fill={false} onClick={() => goBack(formik)} />
                <AppButton type="submit" text="Submit" disabled={!(formik.dirty && formik.isValid)} />
              </Box>
            </Box>
          </form>
        }
      </Box>
    </Box>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser } = auth
  return { currentUser }
}

export default connect(mapStateToProps, {})(ApplicationForm)